/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DnsModule
 */

import { IDnsClientIpMatch } from 'generated-types';
import { DnsClientIpMatch } from 'object-types';

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { IpAddrMatchConfigItem } from
    'ajs/modules/match/factories/ip-addr-match.config-item.factory';

type IDnsClientIpMatchPartial = Omit<IDnsClientIpMatch, 'client_ip'>;

/**
 * Interface for DnsClientIpMatchConfig.
 */
export interface IDnsClientIpMatchConfig extends IDnsClientIpMatchPartial {
    client_ip?: IpAddrMatchConfigItem;
}

/**
 * @desc DnsClientIpMatch MessageItem class.
 * @author Abhinesh Gour
 */
export class DnsClientIpMatchConfigItem extends MessageItem<IDnsClientIpMatchConfig> {
    public static ajsDependencies = [
        'defaultValues',
    ];

    constructor(args = {}) {
        const extendedArgs = {
            objectType: DnsClientIpMatch,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Getter for client_ip.
     */
    public get ipAddrMatchConfig(): IpAddrMatchConfigItem {
        return this.config.client_ip;
    }

    /** @override */
    protected requiredFields(): string[] {
        return [
            'client_ip',
        ];
    }
}
